import * as React from "react";
import theme from "./theme.module.scss";
import QuickReportAction from "../../quickReportAction/QuickReportAction";
import {IReportingPreparedGroup} from "../../../common/interfaces/IReportingPreparedResults";
import MarkeredText from "../../../../../common/components/markered-text/MarkeredText";
import useReportingModel from "../../../common/hooks/useReportingModel";

export interface IReportGroupValueCellProps {
    group: IReportingPreparedGroup;
    onQuickFilter: (group: IReportingPreparedGroup) => void;
}

export default React.memo((props: IReportGroupValueCellProps): React.JSX.Element => {
    const model = useReportingModel();

    const {
        group, onQuickFilter
    } = props;

    return (
        <QuickReportAction iconName="icon-filter" tooltipTitle="Add Filter" item={group} onClick={onQuickFilter}>
            {group.link ? (
                <a className={theme.link} href={group.link} target="_blank">
                    <MarkeredText marker={model.getColumnSearchQuery(group.key)}>
                        {group.value || "-"}
                    </MarkeredText>
                </a>
            ) : (
                <MarkeredText marker={model.getColumnSearchQuery(group.key)}>
                    {group.value || "-"}
                </MarkeredText>
            )}
        </QuickReportAction>
    );
});
